var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_2479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.82617 18.4918C14.7967 18.4918 18.8262 14.4624 18.8262 9.49179C18.8262 4.52123 14.7967 0.491791 9.82617 0.491791C4.85561 0.491791 0.826172 4.52123 0.826172 9.49179C0.826172 14.4624 4.85561 18.4918 9.82617 18.4918Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68617 4.01241C1.97921 4.9322 1.44614 5.99233 1.13574 7.14402H5.81778L2.68617 4.01241Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.516 7.14401C18.2056 5.99237 17.6724 4.93223 16.9655 4.01244L13.834 7.14401H18.516Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13574 11.8397C1.44617 12.9913 1.97925 14.0514 2.68617 14.9712L5.81768 11.8397H1.13574Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3054 2.3523C14.3856 1.64534 13.3255 1.11226 12.1738 0.801834V5.48384L15.3054 2.3523Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34668 16.6313C5.26647 17.3383 6.32661 17.8713 7.47826 18.1818V13.4998L4.34668 16.6313Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47822 0.801834C6.32657 1.11226 5.26644 1.64534 4.34668 2.35226L7.47822 5.4838V0.801834Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 18.1818C13.3255 17.8713 14.3856 17.3383 15.3054 16.6313L12.1738 13.4998V18.1818Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834 11.8397L16.9655 14.9712C17.6724 14.0515 18.2056 12.9913 18.516 11.8397H13.834Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.31789H11.0001H11.0001V0.567974C10.6158 0.517947 10.224 0.491791 9.82617 0.491791C9.42824 0.491791 9.03653 0.517947 8.65227 0.567974V8.31782V8.31785H0.902355C0.852328 8.70215 0.826172 9.09393 0.826172 9.49179C0.826172 9.88972 0.852328 10.2814 0.902355 10.6657H8.6522H8.65223V18.4156C9.03653 18.4656 9.42824 18.4918 9.82617 18.4918C10.224 18.4918 10.6158 18.4657 11.0001 18.4156V10.6658V10.6657H18.75C18.8 10.2814 18.8262 9.88972 18.8262 9.49179C18.8262 9.09393 18.8 8.70215 18.75 8.31789V8.31789Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 11.8397L16.1899 15.8558C16.3746 15.6711 16.5509 15.4781 16.719 15.278L13.2806 11.8396H12.1738V11.8397Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47806 11.8397H7.47799L3.46191 15.8557C3.64655 16.0404 3.8396 16.2166 4.03971 16.3848L7.47806 12.9463V11.8397Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47873 7.14402V7.14395L3.46263 3.12781C3.27791 3.31245 3.10171 3.50549 2.93359 3.7056L6.37198 7.14399H7.47873V7.14402Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 7.14402L16.19 3.12784C16.0053 2.94313 15.8123 2.76693 15.6122 2.59885L12.1738 6.03723V7.14402Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_2479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.826172 0.491791)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.ad177772b230dba75106137f02b4b377.svg";
export { ForwardRef as ReactComponent };